// PaginationBar
// Displays the following in a full-width space-between flexbox:
//  Current range of items of total (such as: 1 - 10 / 200)
//  A page selector with start, end, forward, back, and number buttons
//  A per-page selector, currently with static 20, 50, 100 options, defaulting to 20

import { FormControl, Input, InputLabel, MenuItem, Pagination, Select, SelectChangeEvent } from "@mui/material";

export interface PaginationBarProps {
  totalItems: number,
  perPage?: number,
  currentPage: number,
  onChange?: (currentPage: number, perPage: number) => void,
  perPageOptions?: number[]
}

export function PaginationBar(props: PaginationBarProps) {
  const perPageOptions: number[] = props.perPageOptions !== undefined && props.perPageOptions.length > 0 ? props.perPageOptions : [20, 50, 100];
  const perPage: number = props.perPage !== undefined ? props.perPage : perPageOptions[0];

  let totalPages = Math.ceil(props.totalItems / perPage);

  return (
    <div style={{ width: "100%", padding: "0.5rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

      <small style={{ marginTop: "0.5rem", marginRight: "0.5rem" }}>
        {Math.min(((props.currentPage - 1) * perPage) + 1, props.totalItems)} -&nbsp;
        {Math.min(props.currentPage * perPage, props.totalItems)} / {props.totalItems}
      </small>

      <Pagination size="small"
        count={totalPages}
        page={props.currentPage}
        siblingCount={1}
        boundaryCount={1}
        onChange={(e: React.ChangeEvent<unknown>, _newPage: number) => { props.onChange?.(_newPage, perPage) }}
        showFirstButton={props.currentPage > 2}
        hidePrevButton={props.currentPage === 1}
        showLastButton={props.currentPage < totalPages - 1}
        hideNextButton={props.currentPage === totalPages || !totalPages}
        shape="rounded" />

      <FormControl style={{ marginTop: "0.5rem", minWidth: "5rem" }}>
        <InputLabel>Per Page</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={perPage.toString()}
          input={<Input size="small" />}
          onChange={(e: SelectChangeEvent) => {
            if (props.onChange) {
              // Grab the new per page value, which comes in as a string
              const _perPage = parseInt(e.target.value);
              // Calculate a good page to go to which will keep the current start row in range
              const _newPage = Math.floor(((props.currentPage - 1) * perPage) / _perPage) + 1;
              // Send them to the parent
              props.onChange(_newPage, _perPage)
            }
          }} >
          {perPageOptions.map((value: number) =>
            <MenuItem value={value} key={value}>{value}</MenuItem>
          )}
        </Select>
      </FormControl>

    </div>
  );
}